module.exports = __webpack_public_path__ + "static/media/instagram.3cabd8a5.svg";